import { PlotReportFactElement } from '@/api/rest/resources/types/fact';
import { GraphFact } from '@/components/Charts/types';
import { HabitatIntactnessThreatsHistoricTable } from '@/components/Tables/HabitatIntactnessThreats';
import { NoPlotData } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plot/components/NoPlotData';

export const HabitatIntactnessThreatsTableCard = ({
  timeSeriesFact,
  areaPctFact,
  fiveYearsPctChangeFact,
}: {
  timeSeriesFact?: GraphFact[] | null;
  areaPctFact?: PlotReportFactElement<number>[];
  fiveYearsPctChangeFact?: PlotReportFactElement<number>[];
}) => {
  const hasData =
    (areaPctFact?.length ?? 0) > 0 || (fiveYearsPctChangeFact?.length ?? 0) > 0 || (timeSeriesFact?.length ?? 0) > 0;

  if (!hasData) {
    return <NoPlotData />;
  }

  return (
    <div className='sm:p-6 md:p-8'>
      <HabitatIntactnessThreatsHistoricTable
        threatsTimeSeries={timeSeriesFact ?? []}
        threatsAreaPct={areaPctFact}
        threatsArea5yPct={fiveYearsPctChangeFact}
      />
    </div>
  );
};
